// One-time paid orders on the website (Razorpay): detailed Milan, baby names,
// astrologer consults, dakshina. The order is created on the server with its
// inputs first, then paid, then the server checks Razorpay's signature —
// the page never unlocks anything by itself. See src/orders.py.
import { API } from "./publicShared";

const loadRazorpay = () => new Promise((resolve) => {
  if (window.Razorpay) return resolve(true);
  const s = document.createElement("script");
  s.src = "https://checkout.razorpay.com/v1/checkout.js";
  s.onload = () => resolve(true);
  s.onerror = () => resolve(false);
  document.body.appendChild(s);
});

async function post(path, body) {
  const r = await fetch(`${API}${path}`, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(typeof d.detail === "string" ? d.detail : "Something went wrong. Please try again.");
  return d;
}

export async function getJson(path) {
  const r = await fetch(`${API}${path}`);
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(typeof d.detail === "string" ? d.detail : "Could not load. Please try again.");
  return d;
}

export const postJson = post;

/**
 * Create the order, open Razorpay (UPI first), verify on the server.
 * Resolves to the paid order id, null if the person closed the payment window.
 */
export async function payOrder({ user, kind, inputs, description }) {
  if (!(await loadRazorpay())) throw new Error("Could not open payment. Please check your internet.");
  const o = await post("/orders/create", { user_id: user.id, kind, inputs, channel: "web" });
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: o.key_id, amount: o.amount_paise, currency: "INR", order_id: o.razorpay_order_id,
      name: "VedSanga", description, image: "/logo192.png",
      prefill: { name: user.name || "", email: user.email || "" },
      theme: { color: "#E8832A" },
      handler: async (res) => {
        try {
          await post("/orders/razorpay/verify", {
            user_id: user.id, order_id: o.order_id, razorpay_order_id: res.razorpay_order_id,
            razorpay_payment_id: res.razorpay_payment_id, razorpay_signature: res.razorpay_signature,
          });
          resolve(o.order_id);
        } catch (e) {
          reject(new Error("Payment received but not confirmed yet. Please refresh in a minute — you will not be charged twice."));
        }
      },
      modal: { ondismiss: () => resolve(null) },
    });
    rzp.open();
  });
}

export const inr = (n) => `₹${n}`;
